var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1386,
    height: 805,
    viewBox: "0 0 1386 805",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10033_38392)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1386,
    height: 805,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 734.973L99.7552 750.591C159.51 766.208 279.021 797.443 398.531 769.462C518.042 741.481 637.552 654.284 757.062 608.994C876.573 563.574 996.083 560.19 1115.59 583.095C1235.1 606.131 1354.61 655.586 1414.37 680.313L1474.12 705.04V856.007H1414.37C1354.61 856.007 1235.1 856.007 1115.59 856.007C996.083 856.007 876.573 856.007 757.062 856.007C637.552 856.007 518.042 856.007 398.531 856.007C279.021 856.007 159.51 856.007 99.7552 856.007H40V734.973Z",
    fill: "url(#paint0_linear_10033_38392)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1354.24 713.179L-1290.93 729.056C-1227.63 744.34 -1101.02 776.984 -974.411 800.28C-847.802 824.466 -721.193 839.305 -594.584 800.28C-467.976 760.662 -479.772 633.943 -353.163 578.596C-226.554 522.656 -158.276 459.546 -31.6674 459.101C224.449 419.689 418.286 554.41 544.895 602.337C671.504 649.375 798.463 683.831 955.012 713.179C1093.57 729.056 1223.67 760.217 1350.28 713.179C1476.89 665.252 1557.77 634.536 1621.07 578.596L1684.37 523.249V903.109H1621.07C1557.77 903.109 1431.16 903.109 1304.55 903.109C1177.94 903.109 1051.33 903.109 924.722 903.109C798.113 903.109 671.504 903.109 544.895 903.109C418.286 903.109 291.677 903.109 165.069 903.109C38.4598 903.109 -88.1492 903.109 -214.758 903.109C-341.367 903.109 -467.976 903.109 -594.584 903.109C-721.193 903.109 -847.802 903.109 -974.411 903.109C-1101.02 903.109 -1227.63 903.109 -1290.93 903.109H-1354.24V713.179Z",
    fill: "#FEFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 451.974L53.6433 457.779C107.287 463.584 182.164 477.877 253.688 520.509C355.946 567.727 459.88 652.51 589.518 675.386C686.746 711.002 858.293 733.549 965.58 697.241C1072.87 661.039 1334.38 808.408 1451.72 697.241C1559.01 717.717 1529.95 675.503 1585.27 652.51H1609.3V786.552H1555.66C1502.01 786.552 1394.73 786.552 1287.44 786.552C1180.15 786.552 1072.87 786.552 965.58 786.552C858.293 786.552 751.007 786.552 643.72 786.552C536.433 786.552 429.147 786.552 321.86 786.552C214.573 786.552 107.287 786.552 53.6433 786.552H0V451.974Z",
    fill: "url(#paint1_linear_10033_38392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 672.364L50.9804 690.895C101.961 709.56 203.922 746.623 305.882 759.917C407.843 773.077 509.804 762.334 611.765 739.774C713.726 717.08 815.687 682.704 917.647 694.789C1019.61 706.875 1121.57 765.423 1223.53 765.423C1325.49 765.423 1427.45 706.875 1478.43 677.467L1529.41 648.193V840.219H1478.43C1427.45 840.219 1325.49 840.219 1223.53 840.219C1121.57 840.219 1019.61 840.219 917.647 840.219C815.687 840.219 713.726 840.219 611.765 840.219C509.804 840.219 407.843 840.219 305.882 840.219C203.922 840.219 101.961 840.219 50.9804 840.219H0V672.364Z",
    fill: "#F3F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 584.464L33.0137 592.91C66.0275 601.041 131.863 618.408 198.275 643.432C264.014 668.93 330.137 702.085 395.587 714.953C462 727.347 528.412 719.452 593.862 702.322C659.986 685.508 725.725 660.247 792.137 647.616C857.972 634.986 924 634.986 990.412 639.17C1055.96 643.669 1122.28 651.563 1187.72 668.694C1254.04 685.508 1319.59 710.769 1353.28 723.4L1386 736.03V786.552H1352.99C1319.97 786.552 1254.14 786.552 1187.72 786.552C1121.99 786.552 1055.86 786.552 990.412 786.552C924 786.552 857.587 786.552 792.137 786.552C726.014 786.552 660.275 786.552 593.862 786.552C528.027 786.552 462 786.552 395.587 786.552C330.041 786.552 263.725 786.552 198.275 786.552C131.959 786.552 66.4125 786.552 32.725 786.552H0V584.464Z",
    fill: "url(#paint2_linear_10033_38392)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-78.925 709.916L-6.57713 731.523C65.7708 753.285 210.467 796.498 355.162 811.998C499.858 827.342 644.554 814.816 789.25 788.513C933.946 762.053 1078.64 721.972 1223.34 736.063C1368.03 750.154 1512.73 818.417 1657.42 818.417C1802.12 818.417 1946.82 750.154 2019.16 715.866L2091.51 681.734V905.625H2019.16C1946.82 905.625 1802.12 905.625 1657.42 905.625C1512.73 905.625 1368.03 905.625 1223.34 905.625C1078.64 905.625 933.946 905.625 789.25 905.625C644.554 905.625 499.858 905.625 355.162 905.625C210.467 905.625 65.7708 905.625 -6.57713 905.625H-78.925V709.916Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10033_38392",
    x1: 1073.5,
    y1: 691.57,
    x2: 1087.46,
    y2: 330.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E5E8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10033_38392",
    x1: 804.65,
    y1: 451.974,
    x2: 804.65,
    y2: 786.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10033_38392",
    x1: 693,
    y1: 563.919,
    x2: 693,
    y2: 786.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10033_38392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1386,
    height: 805,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave5);
export default __webpack_public_path__ + "static/media/wave5.0b0088d58daaad680a925a04ac9dbdd4.svg";
export { ForwardRef as ReactComponent };